import type { ReactElement } from 'react';
import { IconCheck } from '@tabler/icons-react';
import { ButtonPreset } from '@/constants/componentPresets';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Cbutton } from '../Cbutton';
import { Cicon } from '../Cicon';
import { Ctext } from '../Ctext';
interface ActivationCompleteAuthBodyProps {
    onClose?: () => void;
}
export function ActivationCompleteAuthBody({ onClose }: ActivationCompleteAuthBodyProps): ReactElement {
    return (
      <div data-el="Cauthmodal/ActivationCompleteAuthBody/Root" key="activation-complete" style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '24px',
            textAlign: 'center',
        }}>
        <Cicon icon={IconCheck} size={64} color={ColorType.Accent}/>
        <Ctext size={24} weight={FontWeight.Bold} color={ColorType.White}>
          Account activated!
        </Ctext>
        <Ctext size={16} weight={FontWeight.Regular} color={ColorType.White} opacity={0.8}>
          Welcome to CABAL. Your account is now active and ready to use.
        </Ctext>
        <Cbutton preset={ButtonPreset.Primary} onClick={onClose} style={{ marginTop: '16px' }}>
          <Ctext size={16} weight={FontWeight.Medium} color={ColorType.White}>
            Get Started
          </Ctext>
        </Cbutton>
      </div>
    );
}
